import React, { Fragment, useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import CaretIconSmall from '../../CaretIconSmall'
import {
  Cell,
  Row,
  Table,
  TitleCell,
  StyledTd,
  TableWrapper,
} from './component.styles'

const AutoTableRowCollapsible = React.forwardRef(
  (
    {
      colGroupWidths,
      columns,
      id,
      multiColSpanValue,
      resolveCellValue,
      resolveClassName,
      rowClassName,
      rowSet,
    },
    ref,
  ) => {
    const tableRef = useRef(null)
    const [isOpen, setIsOpen] = useState(true)
    const [collapsibleHeight, setCollapsibleHeight] = useState(0)

    useEffect(() => {
      if (tableRef.current) {
        setCollapsibleHeight(tableRef.current.scrollHeight)
      }
    }, [])

    const titleRow = rowSet[0]
    const titleRowClassName = resolveClassName(rowClassName, titleRow)
    const titleRowKey = `${id}_tr_title_row`
    const childRows = rowSet.slice(1)

    return (
      <Fragment key={`${id}-${rowClassName}-${titleRowKey}`}>
        <Row
          className={titleRowClassName}
          colSpan={multiColSpanValue}
          isTitleRow
          key={titleRowKey}
          onClick={() => setIsOpen(!isOpen)}
          ref={ref}
        >
          {columns.map((column, colIndex) => {
            const resolvedCellData = resolveCellValue(column, titleRow)
            const resolvedCellClassName = resolveClassName(
              column.cellClassName,
              titleRow,
            )

            if (!resolvedCellData) return null

            return (
              <TitleCell
                colSpan={multiColSpanValue}
                isOpen={isOpen}
                isTitleRow
                key={`${id}_td_${colIndex}`}
              >
                <div className={resolvedCellClassName}>{resolvedCellData}</div>
                {colIndex === 0 && <CaretIconSmall />}
              </TitleCell>
            )
          })}
        </Row>
        <Row>
          <StyledTd colSpan={multiColSpanValue} isOpen={isOpen}>
            <TableWrapper
              isOpen={isOpen}
              maxHeight={collapsibleHeight}
              ref={tableRef}
            >
              <Table>
                <colgroup>
                  {colGroupWidths.map(width => (
                    <col key={`col-${width}`} style={{ width: `${width}` }} />
                  ))}
                </colgroup>
                <tbody>
                  {childRows.map((row, index) => {
                    const resolvedClassName = resolveClassName(
                      rowClassName,
                      row,
                    )
                    return row.type === 'sub-title' ? (
                      <Row className="sub-title-row">
                        <Cell
                          colSpan={multiColSpanValue}
                          key={`${id}_td_${(index + 1) * index}`}
                        >
                          {row.title}
                        </Cell>
                      </Row>
                    ) : (
                      <Row
                        className={resolvedClassName}
                        key={`${id}_tr_${index}`}
                        ref={ref}
                      >
                        {columns.map((column, colIndex) => {
                          const resolvedCellData = resolveCellValue(column, row)
                          const resolvedCellClassName = resolveClassName(
                            column.cellClassName,
                            row,
                          )
                          if (!resolvedCellData) return null
                          return (
                            <Cell
                              colSpan={1}
                              key={`${id}_td_${(index + 1) * colIndex}`}
                            >
                              <div className={resolvedCellClassName}>
                                {resolvedCellData}
                              </div>
                            </Cell>
                          )
                        })}
                      </Row>
                    )
                  })}
                </tbody>
              </Table>
            </TableWrapper>
          </StyledTd>
        </Row>
      </Fragment>
    )
  },
)

AutoTableRowCollapsible.propTypes = {
  colGroupWidths: PropTypes.array,
  columns: PropTypes.array,
  id: PropTypes.string,
  multiColSpanValue: PropTypes.string,
  resolveCellValue: PropTypes.string,
  resolveClassName: PropTypes.string,
  rowClassName: PropTypes.string,
  rowSet: PropTypes.array,
}

export default AutoTableRowCollapsible
